import styled from "styled-components/macro";

export const Wrapper = styled.div`
  display: flex;
  gap: var(--gap);

  & > * { width: 100% }
`;